import Parse from "./parse.service";

/**
 * Uploads an image file with progress tracking and timeout
 * @param {File} file - The image file to upload
 * @param {Function} setProgress - Callback function to update upload progress
 * @returns {Promise<Parse.File>} Uploaded file object
 * @throws {Error} If upload fails or times out after 25 seconds
 */
export async function uploadImage(file, setProgress) {
    const currentTime = Date.now().toString();
    const name = "Images" + currentTime;

    // Create a timeout promise that rejects after 25 seconds
    const timeoutPromise = new Promise((_, reject) =>
        setTimeout(() => reject(new Error('Timeout: Upload took too long')), 25000)
    );
    try {
        // Use Promise.race to execute both the upload and timeout concurrently
        const result = await Promise.race([
            (async () => {
                var parseFile = new Parse.File(name, file);
                return await parseFile.save({
                    progress: (progressValue, loaded, total, { type }) => {
                        if (type === "upload" && progressValue !== null) {
                            setProgress(Number((progressValue * 100).toFixed(2)));
                        }
                    },
                    error: (error) => {
                        throw new Error("file upload failed", error);
                    },

                });
            })(),
            timeoutPromise
        ]);

        return result;
    } catch (error) {
        console.log("Error uploading file:", error);
    }
}


